/** @jsx jsx */
import { jsx } from "theme-ui"

import {
  FoodIcon,
  GroupIcon,
  PharmaIcon,
  ContactIcon,
  EnvironmentIcon,
  ArrowIcon,
  SearchIcon,
  CloseIcon,
  LeftIcon,
  RightIcon,
  Pin,
} from "../assets/icons"

const Icon = ({ icon, style = {} }) => {
  switch (icon) {
    case "food":
      return <FoodIcon style={style} />
    case "contact":
      return <ContactIcon style={style} />
    case "pharma":
      return <PharmaIcon style={style} />
    case "group":
      return <GroupIcon style={style} />
    case "environment":
      return <EnvironmentIcon style={style} />
    case "arrow":
      return <ArrowIcon style={style} />
    case "search":
      return <SearchIcon style={style} />
    case "close":
      return <CloseIcon style={style} />
    case "left":
      return <LeftIcon style={style} />
    case "right":
      return <RightIcon style={style} />
    case "pin":
      return <Pin style={style} />
    default:
      return <GroupIcon style={style} />
  }
}

export default Icon
